import { registerEvents } from "./skyward.ui.events";
import { swapSvg } from "./skyward.ui.svg";
import { JQueryInput } from "./types/util/jquery";
import { registerLayoutResizeCallback, registerLoadDOMCallback } from "#skyward_window";

const classNames =
{
    unlockedHeader: "unlockedHeader",
    toolbarBrowseControls: "toolbar--browseControls",
    unlockedBrowseBody: "unlockedBrowseBody",
    collapsePanelHeader: "collapsePanelHeader",
    collapsePanelContents: "collapsePanelContents",
    toCollapse: "toCollapse",
    collapsePanel: "collapsePanel",
    browseFooter: "browseFooter",
    collapsed: "collapsed",
    collapse: "collapse",
    expanded: "expanded",
    expand: "expand",
};

const events =
{
    init,
    toggle,
    collapseAll,
    expandAll
};

registerEvents("collapsePanel", events);

registerLoadDOMCallback(init);

registerLayoutResizeCallback(resizePanels);

export function show(collapsePanel: JQuery<HTMLElement>)
{
    const header = collapsePanel.find(`.${classNames.collapsePanelHeader}`);
    const contents = collapsePanel.find(`.${classNames.collapsePanelContents}`);

    if (contents.hasClass(classNames.collapsed))
    {
        localToggle(contents, header, false);
        resizePanels();
    }
}

export function toggle(this: JQueryInput)
{
    const header = $(this);
    const contents = header.siblings(`.${classNames.collapsePanelContents}`);
    localToggle(contents, header, contents.hasClass(classNames.expanded));

    resizePanels();
}

export function expandAll()
{
    $(`.${classNames.collapsePanel}`).each(function ()
    {
        const contents = $(this).children(`.${classNames.collapsePanelContents}`);
        const header = $(this).children(`.${classNames.collapsePanelHeader}`);
        if (contents.hasClass(classNames.collapsed))
        {
            localToggle(contents, header, false);
        }
    });
}

export function collapseAll()
{
    $(`.${classNames.collapsePanel}`).each(function ()
    {
        const contents = $(this).children(`.${classNames.collapsePanelContents}`);
        const header = $(this).children(`.${classNames.collapsePanelHeader}`);
        if (contents.hasClass(classNames.expanded))
        {
            localToggle(contents, header, true);
        }
    });
}

function init(selector: JQueryInput)
{
    const collapsePanel = $(selector);
    const toCollapse = collapsePanel.find(`.${classNames.toCollapse}`)
    toCollapse.removeClass(`expanded ${classNames.toCollapse}`).addClass(classNames.collapsed);

    if (collapsePanel.data("dirty") === true)
    {
        //@ts-ignore Cannot import changeTracking due to circular dependency
        skyward.changeTracking.getChangeTracker(collapsePanel)?.overrideDirtyState(true);
    }
}

function localToggle(contents: JQuery<HTMLElement>, header: JQuery<HTMLElement>, expanded: boolean)
{
    const remove = expanded ? `${classNames.expanded}` : `${classNames.collapsed}`;
    const add = expanded ? `${classNames.collapsed}` : `${classNames.expanded}`;
    const text = expanded ? "Expand" : "Collapse";
    const findSelector = expanded ? `.${classNames.collapse}` : `.${classNames.expand}`;

    const svg = swapSvg(header.find(findSelector) as JQuery<SVGElement>, text, 'CollapsePanel');

    contents.removeClass(remove);
    contents.addClass(add);

    svg.attr("aria-label", text);

    contents.trigger('collapsepanel:toggled', {
        expanded: !expanded
    });

    $(window).trigger("resize");
}

function resizePanels()
{
    $(`.${classNames.collapsePanel}`).each(function (this: JQueryInput<HTMLElement>)
    {
        const panel = $(this);

        const unlockedHeader = panel.find(`.${classNames.unlockedHeader}`);
        if (unlockedHeader.length > 0)
        {
            unlockedHeader.width(panel.width()! - 5);
        }

        const unlockedBrowseBody = panel.find(`.${classNames.unlockedBrowseBody}`);
        if (unlockedBrowseBody.length > 0)
        {
            unlockedBrowseBody.width(panel.width()! - 5);
        }

        const footer = panel.find(`.${classNames.browseFooter}`);
        if (footer.length > 0)
        {
            footer.width(panel.width()! - 5);
        }

        const browseControls = panel.find(`.${classNames.toolbarBrowseControls}`);
        if (browseControls.length > 0)
        {
            browseControls.width(panel.width()! - 5);
            browseControls.width(panel.width()! - 5);
        }
    });
}